import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnimatedButton from "../AnimatedButton/AnimatedButton";

const rubikfont = {
    fontFamily: "Rubik, san-serif"
};

const Layout3 = ({ data }) => {
    const products = data?.product_id || [];

    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
        window.scrollTo(0, 0);
    };

    return (
        <Paper sx={{ py: { xs: 5, md: 8 }, padding: { xs: 2, md: 4 }, boxShadow: "none", backgroundColor: "#F6F4EF" }}>
            <Box sx={{ textAlign: "center", mb: 6 }}>
                {/* header title */}
                <Typography
                    sx={{
                        fontSize: { xs: "32px", sm: "48px", md: "56px" },
                        color: "#222",
                        ...rubikfont,
                        fontWeight: 900,
                        lineHeight: 1.1,
                        letterSpacing: "3.5px",
                        textTransform: "uppercase"
                    }}
                >
                    {data?.title || "New Arrivals"}
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#666",
                        ...rubikfont,
                        maxWidth: "600px",
                        margin: "0 auto",
                    }}
                >
                    Discover our latest grooming innovations and fresh products
                </Typography>
            </Box>

            {/* Masonry Grid */}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(2, 1fr)",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(5, 1fr)",
                    },
                    gap: { xs: 2, md: 3 },
                    justifyItems: "center",
                    alignItems: "center",
                }}
            >
                {products.map((product, index) => (
                    <Box
                        key={product._id || index}
                        onClick={() => handleProductClick(product._id)}
                        sx={{
                            borderRadius: 3,
                            overflow: "hidden",
                            cursor: "pointer",
                            transition: "all 0.4s ease",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            aspectRatio: "1 / 1", // ✅ keeps square shape
                            width: "100%", // ensures equal width across breakpoints
                            "&:hover": {
                                transform: "translateY(-8px)",
                                boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                            },
                        }}
                    >
                        <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
                            <img
                                src={product.product_images?.[0] || "https://via.placeholder.com/300"}
                                alt={product.title}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                              {/* B2B Discount Badge */}
                                                        {product.b2b_discountValue && (
                                                            <Box
                                                                sx={{
                                                                    position: "absolute",
                                                                    top: 8,
                                                                    left: 8,
                                                                    bgcolor: "#146514ff",
                                                                    color: "white",
                                                                    px: 1.5,
                                                                    py: 0.5,
                                                                    borderRadius: 1,
                                                                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                                                    fontWeight: 600,
                                                                    ...rubikfont,
                                                                    zIndex: 2,
                                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                                }}
                                                            >
                                                                {product.b2b_discountType === "percentage" 
                                                                    ? `${product.b2b_discountValue}% OFF`
                                                                    : `₹${product.b2b_discountValue} OFF`
                                                                }
                                                            </Box>
                                                        )}
                            <Box
                                sx={{
                                    position: "absolute",
                                    inset: 0,
                                    background:
                                        "linear-gradient(to bottom, transparent, rgba(0,0,0,0.7))",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    p: { xs: 2, md: 3 },
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "white",
                                        fontSize: { xs: "16px", md: "20px" },
                                        fontWeight: 700,
                                        mb: 0.5,
                                        ...rubikfont,
                                    }}
                                >
                                    {product.title}
                                </Typography>
                                {/*b2b_sellingPrice */}
                                <Typography
                                    sx={{
                                        color: "white",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        ...rubikfont,
                                    }}
                                >
                                    ₹{product.b2b_sellingPrice}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
            {/* View All Button */}
            <Box sx={{ textAlign: "center", mt: 6, display: "flex", gap: 3, flexWrap: "wrap", justifyContent: "center" }}>
                <AnimatedButton text="View All  →" onClick={() => navigate('/search', { state: { layoutId: data._id, title: data.title } })} />
            </Box>
        </Paper>
    );
};

export default Layout3;
